// ============================================================================
// Web-specific configuration for the Stalkie SPA.
// Adapted from lib/config.ts — replaces RN-specific env vars with Vite equivalents.
// ============================================================================

export const FREE_PLAN_LIMIT = 0;

export function isProduction(): boolean {
  return import.meta.env.PROD;
}

export function isMockEnabled(): boolean {
  if (isProduction()) return false;
  return import.meta.env.VITE_MOCK_ENABLED === "true";
}

export const MOCK_ENABLED = !isProduction() && import.meta.env.VITE_MOCK_ENABLED === "true";

export const USER_DEFAULTS = {
  notificationsEnabled: false,
  timezone: "America/Sao_Paulo",
  digestFrequency: "NONE" as const,
  isPremium: false,
  planLimit: FREE_PLAN_LIMIT,
  planKey: "free",
};

export const MONITORED_ACCOUNT_DEFAULTS = {
  status: "ACTIVE" as const,
  statusUpdatedAt: Date.now(),
  followingCount: 0,
  followersCount: 0,
  scrapeTier: "STANDARD" as const,
  errorCount: 0,
  nextScrapeAt: Date.now(),
};

export const USER_MONITOR_DEFAULTS = {
  isActive: true,
  notifyFollowingChanges: true,
  notifyDigest: true,
};

export const API_TIMEOUT_MS = 30000;
export const DEFAULT_RETRY_COUNT = 5;
export const BACKOFF_INITIAL_DELAY_MS = 1000;
export const BACKOFF_MAX_DELAY_MS = 30000;
export const CIRCUIT_BREAKER_FAILURE_THRESHOLD = 5;
export const CIRCUIT_BREAKER_TIMEOUT_MS = 30000;
export const RATE_LIMIT_FAILURE_THRESHOLD = 3;
export const RATE_LIMIT_TIMEOUT_MS = 5 * 60 * 1000;

export const CACHE_TTL = {
  SHORT: 5 * 60 * 1000,
  MEDIUM: 30 * 60 * 1000,
  LONG: 2 * 60 * 60 * 1000,
  VERY_LONG: 6 * 60 * 60 * 1000,
  DAY: 24 * 60 * 60 * 1000,
  WEEK: 7 * 24 * 60 * 60 * 1000,
} as const;

export const ENVIRONMENT_POLICY = {
  get mockEnabled() {
    return isMockEnabled();
  },
  minSuccessLoadingTimeMs: 1500,
  deriveCustomerIdServerSide: true,
  allowBusinessScraping: true,
  normalizeHandles: true,
  enforceConvexValidation: true,
  externalHttpCallsInInternalActions: true,
  preferDbGetOverFilter: true,
  requireIndexForFilterOnHighCardinality: true,
  freeUsersPrivacyGating: true,
  serverSideCustomerId: true,
  strictTypeSafety: true,
  standardizedErrorHandling: true,
} as const;

export const SHARED_DEFAULTS = {
  USER_DEFAULTS,
  MONITORED_ACCOUNT_DEFAULTS,
  USER_MONITOR_DEFAULTS,
  API_TIMEOUT_MS,
  DEFAULT_RETRY_COUNT,
  BACKOFF_INITIAL_DELAY_MS,
  BACKOFF_MAX_DELAY_MS,
  CIRCUIT_BREAKER_FAILURE_THRESHOLD,
  CIRCUIT_BREAKER_TIMEOUT_MS,
  RATE_LIMIT_FAILURE_THRESHOLD,
  RATE_LIMIT_TIMEOUT_MS,
  CACHE_TTL,
  ENVIRONMENT_POLICY,
} as const;

export const LANDING_METRICS_CONFIG = {
  searchesCount: "50k+",
  profilesCheckedCount: "100k+",
  averageRating: "4.6/5",
  passwordRequired: false,
  useQualitativeClaims: true,
};

